import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  '@font-face': {
    fontFamily: 'Maharlika',
    src: 'url(../../assets/fonts/Maharlika.ttf)'
  },
  navbarContainer: {
    width: '100vw',
    height: '64px',
    backgroundColor: '#DBB793',
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '64px',
    fontSize: '26pt',
    fontFamily: 'Maharlika',
    letterSpacing: '-2px',
    position: 'fixed',
    color: 'white',
    zIndex: '9999'
  },
  emptySpace: {
    width: '100vw',
    height: '64px',
  },
  openSideBar: {
    marginTop: '5px',
    marginLeft: '60px',
    fontSize: '25pt',
    color: 'white',
    cursor: 'pointer'
  },
  cartIcon: {
    marginTop: '5px',
    marginRight: '60px',
    fontSize: '25pt',
    color: 'white',
    cursor: 'pointer'
  },
  '@media (max-width:780px)': {
    navbarContainer: {
      fontSize: '22pt',
    },
    cartIcon: {
      marginRight: '10px',
    },
    openSideBar: {
      marginLeft: '10px',
    },
  }
}));
